import React from 'react'
import cn from 'classnames'
import { Button } from 'antd'
import { t } from '../../../../config/i18n'
import styles from './SelectEntity.module.scss'

interface Props {
  entityList: string[]
  onSelect: (entity: string) => void
  style?: React.CSSProperties
  className?: string
}

export const CatalogBindingsSelectEntity = ({ entityList, onSelect, style, className }: Props) => (
  <div className={cn(styles.root, className)} style={style}>
    <div className={styles.text}>
      {t.catalog.addBinding}:
    </div>

    <Button.Group>
      {entityList.map(entity => (
        <Button key={entity} onClick={() => onSelect(entity)}>{entity}</Button>
      ))}
    </Button.Group>
  </div>
)
